module.exports = __webpack_public_path__ + "img/沙發區.b82bf8af.jpg";